import React from 'react';
import { SearchIcon, FilterIcon, MapPinIcon, ClockIcon, TrendingUpIcon, UsersIcon, HeartIcon } from 'lucide-react';
import Card from '../components/Card';
import Button from '../components/Button';
import { Link } from 'react-router-dom';
const InvestorPortal = () => {
  return <div data-id="element-1729">
      <div className="mb-6" data-id="element-1730">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-1731">
          Investor Portal
        </h1>
        <p className="text-neutral-400" data-id="element-1732">
          Discover Shariah-compliant investment opportunities
        </p>
      </div>
      {/* Investor Dashboard Summary */}
      <section className="mb-8" data-id="element-1733">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1734">
          <Card data-id="element-1735">
            <div className="flex items-center mb-4" data-id="element-1736">
              <div className="w-10 h-10 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-1737">
                <TrendingUpIcon className="w-5 h-5 text-primary" data-id="element-1738" />
              </div>
              <div data-id="element-1739">
                <h3 className="font-medium" data-id="element-1740">Portfolio Value</h3>
              </div>
            </div>
            <div className="text-2xl font-bold mb-1" data-id="element-1741">RM 75,000</div>
            <div className="text-sm text-success flex items-center" data-id="element-1742">
              <TrendingUpIcon className="w-4 h-4 mr-1" data-id="element-1743" />
              <span data-id="element-1744">+4.5% this month</span>
            </div>
          </Card>
          <Card data-id="element-1745">
            <div className="flex items-center mb-4" data-id="element-1746">
              <div className="w-10 h-10 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-3" data-id="element-1747">
                <UsersIcon className="w-5 h-5 text-secondary" data-id="element-1748" />
              </div>
              <div data-id="element-1749">
                <h3 className="font-medium" data-id="element-1750">Businesses Supported</h3>
              </div>
            </div>
            <div className="text-2xl font-bold mb-1" data-id="element-1751">12</div>
            <div className="text-sm text-neutral-400" data-id="element-1752">Across 5 industries</div>
          </Card>
          <Card data-id="element-1753">
            <div className="flex items-center mb-4" data-id="element-1754">
              <div className="w-10 h-10 rounded-full bg-accent bg-opacity-10 flex items-center justify-center mr-3" data-id="element-1755">
                <HeartIcon className="w-5 h-5 text-accent" data-id="element-1756" />
              </div>
              <div data-id="element-1757">
                <h3 className="font-medium" data-id="element-1758">Impact Score</h3>
              </div>
            </div>
            <div className="text-2xl font-bold mb-1" data-id="element-1759">87/100</div>
            <div className="text-sm text-success" data-id="element-1760">Top 10% of investors</div>
          </Card>
        </div>
      </section>
      {/* Sukuk Marketplace */}
      <section className="mb-8" data-id="element-1761">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4" data-id="element-1762">
          <h2 className="text-xl font-bold" data-id="element-1763">Sukuk Marketplace</h2>
          <div className="flex mt-3 sm:mt-0" data-id="element-1764">
            <div className="relative mr-2" data-id="element-1765">
              <input type="text" placeholder="Search businesses" className="pl-9 pr-4 py-2 border border-neutral-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" data-id="element-1766" />
              <SearchIcon className="w-4 h-4 absolute left-3 top-3 text-neutral-400" data-id="element-1767" />
            </div>
            <Button variant="outline" icon={<FilterIcon className="w-4 h-4" data-id="element-1769" />} iconPosition="left" data-id="element-1768">
              Filter
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1770">
          {/* Business Profile Card 1 */}
          <Card padding="none" className="overflow-hidden" data-id="element-1771">
            <div className="h-40 bg-cover bg-center" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80')"
          }} data-id="element-1772"></div>
            <div className="p-4" data-id="element-1773">
              <div className="flex justify-between items-start mb-3" data-id="element-1774">
                <h3 className="font-bold" data-id="element-1775">Amani Cafe</h3>
                <div className="bg-primary bg-opacity-10 text-primary px-2 py-1 rounded text-xs font-medium" data-id="element-1776">
                  Food & Beverage
                </div>
              </div>
              <div className="flex items-center text-sm text-neutral-400 mb-3" data-id="element-1777">
                <MapPinIcon className="w-4 h-4 mr-1" data-id="element-1778" />
                <span data-id="element-1779">Kuala Lumpur</span>
              </div>
              <p className="text-sm mb-4" data-id="element-1780">
                Specialty coffee shop seeking funds for new equipment to expand
                product offerings.
              </p>
              <div className="mb-4" data-id="element-1781">
                <div className="flex justify-between text-sm mb-1" data-id="element-1782">
                  <span data-id="element-1783">Funding Progress</span>
                  <span data-id="element-1784">65% (RM 32,500)</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-1785">
                  <div className="bg-primary h-2 rounded-full" style={{
                  width: '65%'
                }} data-id="element-1786"></div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1787">
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1788">
                  <div className="text-xs text-neutral-400" data-id="element-1789">Amount</div>
                  <div className="font-medium" data-id="element-1790">RM 50,000</div>
                </div>
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1791">
                  <div className="text-xs text-neutral-400" data-id="element-1792">Term</div>
                  <div className="font-medium" data-id="element-1793">6 months</div>
                </div>
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1794">
                  <div className="text-xs text-neutral-400" data-id="element-1795">Profit Rate</div>
                  <div className="font-medium" data-id="element-1796">5% p.a.</div>
                </div>
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1797">
                  <div className="text-xs text-neutral-400" data-id="element-1798">Risk Rating</div>
                  <div className="font-medium text-success" data-id="element-1799">Low</div>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-1800">
                <div className="flex items-center text-xs text-neutral-400" data-id="element-1801">
                  <ClockIcon className="w-3 h-3 mr-1" data-id="element-1802" />
                  <span data-id="element-1803">10 days left</span>
                </div>
                <Link to="/demo/micro-sukuk-details" data-id="element-1804">
                  <Button variant="primary" data-id="element-1805">Invest Now</Button>
                </Link>
              </div>
            </div>
          </Card>
          {/* Business Profile Card 2 */}
          <Card padding="none" className="overflow-hidden" data-id="element-1806">
            <div className="h-40 bg-cover bg-center" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1604719312566-8912e9227c6a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80')"
          }} data-id="element-1807"></div>
            <div className="p-4" data-id="element-1808">
              <div className="flex justify-between items-start mb-3" data-id="element-1809">
                <h3 className="font-bold" data-id="element-1810">GreenTech Solutions</h3>
                <div className="bg-success bg-opacity-10 text-success px-2 py-1 rounded text-xs font-medium" data-id="element-1811">
                  Eco-friendly
                </div>
              </div>
              <div className="flex items-center text-sm text-neutral-400 mb-3" data-id="element-1812">
                <MapPinIcon className="w-4 h-4 mr-1" data-id="element-1813" />
                <span data-id="element-1814">Penang</span>
              </div>
              <p className="text-sm mb-4" data-id="element-1815">
                Sustainable products manufacturer seeking inventory financing
                for upcoming orders.
              </p>
              <div className="mb-4" data-id="element-1816">
                <div className="flex justify-between text-sm mb-1" data-id="element-1817">
                  <span data-id="element-1818">Funding Progress</span>
                  <span data-id="element-1819">40% (RM 20,000)</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-1820">
                  <div className="bg-primary h-2 rounded-full" style={{
                  width: '40%'
                }} data-id="element-1821"></div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1822">
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1823">
                  <div className="text-xs text-neutral-400" data-id="element-1824">Amount</div>
                  <div className="font-medium" data-id="element-1825">RM 50,000</div>
                </div>
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1826">
                  <div className="text-xs text-neutral-400" data-id="element-1827">Term</div>
                  <div className="font-medium" data-id="element-1828">9 months</div>
                </div>
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1829">
                  <div className="text-xs text-neutral-400" data-id="element-1830">Profit Rate</div>
                  <div className="font-medium" data-id="element-1831">6% p.a.</div>
                </div>
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1832">
                  <div className="text-xs text-neutral-400" data-id="element-1833">Risk Rating</div>
                  <div className="font-medium text-warning" data-id="element-1834">Medium</div>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-1835">
                <div className="flex items-center text-xs text-neutral-400" data-id="element-1836">
                  <ClockIcon className="w-3 h-3 mr-1" data-id="element-1837" />
                  <span data-id="element-1838">15 days left</span>
                </div>
                <Link to="/demo/micro-sukuk-details" data-id="element-1839">
                  <Button variant="primary" data-id="element-1840">Invest Now</Button>
                </Link>
              </div>
            </div>
          </Card>
          {/* Business Profile Card 3 */}
          <Card padding="none" className="overflow-hidden" data-id="element-1841">
            <div className="h-40 bg-cover bg-center" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=600&q=80')"
          }} data-id="element-1842"></div>
            <div className="p-4" data-id="element-1843">
              <div className="flex justify-between items-start mb-3" data-id="element-1844">
                <h3 className="font-bold" data-id="element-1845">Modest Fashion House</h3>
                <div className="bg-secondary bg-opacity-10 text-secondary px-2 py-1 rounded text-xs font-medium" data-id="element-1846">
                  Retail
                </div>
              </div>
              <div className="flex items-center text-sm text-neutral-400 mb-3" data-id="element-1847">
                <MapPinIcon className="w-4 h-4 mr-1" data-id="element-1848" />
                <span data-id="element-1849">Johor Bahru</span>
              </div>
              <p className="text-sm mb-4" data-id="element-1850">
                Modest fashion brand expanding to a new location and increasing
                inventory.
              </p>
              <div className="mb-4" data-id="element-1851">
                <div className="flex justify-between text-sm mb-1" data-id="element-1852">
                  <span data-id="element-1853">Funding Progress</span>
                  <span data-id="element-1854">80% (RM 64,000)</span>
                </div>
                <div className="w-full bg-neutral-200 rounded-full h-2" data-id="element-1855">
                  <div className="bg-primary h-2 rounded-full" style={{
                  width: '80%'
                }} data-id="element-1856"></div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1857">
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1858">
                  <div className="text-xs text-neutral-400" data-id="element-1859">Amount</div>
                  <div className="font-medium" data-id="element-1860">RM 80,000</div>
                </div>
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1861">
                  <div className="text-xs text-neutral-400" data-id="element-1862">Term</div>
                  <div className="font-medium" data-id="element-1863">12 months</div>
                </div>
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1864">
                  <div className="text-xs text-neutral-400" data-id="element-1865">Profit Rate</div>
                  <div className="font-medium" data-id="element-1866">5.5% p.a.</div>
                </div>
                <div className="bg-neutral-50 p-2 rounded" data-id="element-1867">
                  <div className="text-xs text-neutral-400" data-id="element-1868">Risk Rating</div>
                  <div className="font-medium text-warning" data-id="element-1869">Medium</div>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-1870">
                <div className="flex items-center text-xs text-neutral-400" data-id="element-1871">
                  <ClockIcon className="w-3 h-3 mr-1" data-id="element-1872" />
                  <span data-id="element-1873">5 days left</span>
                </div>
                <Link to="/demo/micro-sukuk-details" data-id="element-1874">
                  <Button variant="primary" data-id="element-1875">Invest Now</Button>
                </Link>
              </div>
            </div>
          </Card>
        </div>
        <div className="mt-6 text-center" data-id="element-1876">
          <Button variant="outline" data-id="element-1877">View All Opportunities</Button>
        </div>
      </section>
      {/* Community Rewards Hub */}
      <section data-id="element-1878">
        <h2 className="text-xl font-bold mb-4" data-id="element-1879">Community Rewards Hub</h2>
        <Card data-id="element-1880">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1881">
            <div className="md:col-span-2" data-id="element-1882">
              <h3 className="font-medium mb-4" data-id="element-1883">Your Rewards</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1884">
                <div className="border border-neutral-100 rounded-lg p-4" data-id="element-1885">
                  <div className="flex justify-between items-start mb-3" data-id="element-1886">
                    <div className="bg-accent bg-opacity-10 text-accent px-2 py-1 rounded text-xs font-medium" data-id="element-1887">
                      Discount Voucher
                    </div>
                    <div className="text-xs text-neutral-400" data-id="element-1888">
                      From: Amani Cafe
                    </div>
                  </div>
                  <h4 className="font-medium mb-1" data-id="element-1889">10% Off Any Coffee</h4>
                  <p className="text-sm text-neutral-400 mb-3" data-id="element-1890">
                    Valid for all investors
                  </p>
                  <div className="flex items-center text-xs text-neutral-400" data-id="element-1891">
                    <ClockIcon className="w-3 h-3 mr-1" data-id="element-1892" />
                    <span data-id="element-1893">Expires: 31 Dec 2027</span>
                  </div>
                </div>
                <div className="border border-neutral-100 rounded-lg p-4" data-id="element-1894">
                  <div className="flex justify-between items-start mb-3" data-id="element-1895">
                    <div className="bg-primary bg-opacity-10 text-primary px-2 py-1 rounded text-xs font-medium" data-id="element-1896">
                      Special Access
                    </div>
                    <div className="text-xs text-neutral-400" data-id="element-1897">
                      From: GreenTech
                    </div>
                  </div>
                  <h4 className="font-medium mb-1" data-id="element-1898">Early Product Access</h4>
                  <p className="text-sm text-neutral-400 mb-3" data-id="element-1899">
                    Preview new sustainable products
                  </p>
                  <div className="flex items-center text-xs text-neutral-400" data-id="element-1900">
                    <ClockIcon className="w-3 h-3 mr-1" data-id="element-1901" />
                    <span data-id="element-1902">Valid until: 15 Nov 2027</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg" data-id="element-1903">
              <h3 className="font-medium mb-3" data-id="element-1904">Impact Summary</h3>
              <div className="space-y-4" data-id="element-1905">
                <div data-id="element-1906">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-1907">
                    Businesses Supported
                  </div>
                  <div className="text-xl font-bold" data-id="element-1908">12</div>
                </div>
                <div data-id="element-1909">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-1910">
                    Jobs Created
                  </div>
                  <div className="text-xl font-bold" data-id="element-1911">35+</div>
                </div>
                <div data-id="element-1912">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-1913">
                    Green Initiatives
                  </div>
                  <div className="text-xl font-bold" data-id="element-1914">8</div>
                </div>
                <div data-id="element-1915">
                  <div className="text-sm text-neutral-400 mb-1" data-id="element-1916">
                    Community Benefits
                  </div>
                  <div className="text-xl font-bold" data-id="element-1917">15</div>
                </div>
              </div>
              <div className="mt-4" data-id="element-1918">
                <Button variant="secondary" size="sm" fullWidth data-id="element-1919">
                  View Impact Report
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </section>
    </div>;
};
export default InvestorPortal;